<div class="card checkout-shipping-form shadow-none border-0 shadow-none">
  <div class="card-body">
    <div class="edit-profile__body">
      <div *ngIf="!isSaved && !isLoaderActive" #textContainer>
        <p>
          <b>
            <!-- Date -->
            {{ "agreement.date" | translate }}:
          </b>
          {{ currentDate }}
        </p>
        <p>
          <b>
            <!-- Country -->
            {{ "agreement.country" | translate }}:</b
          >
          {{ translated_country }}
        </p>
        <p>
          <b>
            <!-- State/Region -->
            {{ "agreement.stateRegion" | translate }}:</b
          >
          {{ translated_region }}
        </p>
        <p class="mt-1" style="text-indent: 25px">
          <!-- I, {{ personalInfo.first_name }} {{ personalInfo.last_name }} ({{
            personalInfo.email
          }}; {{ phoneNumber }} -->
          {{ 'agreement.introTextStart' | translate:{
             firstName: personalInfo.first_name,
             lastName: personalInfo.last_name,
             email: personalInfo.email,
             phone: phoneNumber,
           } }}
          <span
            class="eye"
            (click)="toggleShowPhone()"
            style="cursor: pointer; margin-left: -20px"
          >
            <i *ngIf="isPhoneVisible" class="fas fa-eye-slash"></i>
            <i *ngIf="!isPhoneVisible" class="fas fa-eye"></i>
          </span>
          <!-- ), a resident of the {{ personalInfo.country }}, hereby designate
          GotYourBack Technologies Ltd. as my authorized agent (“Agent”) for the
          sole purpose of acting on my behalf in connection with the exercise of
          my data privacy rights under applicable privacy legislation, including
          but not limited to: -->
          {{
            "agreement.introTextEnd"
              | translate
                : {
                    country: translated_country
                  }
          }}
        </p>
        <ul class="mt-1 agreement-list">
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.ccpa' | translate"
          >
            <!-- The California Consumer Privacy Act (CCPA) and California Privacy
            Rights Act (CPRA); -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.gdpr' | translate"
          >
            <!-- The European Union’s General Data Protection Regulation (GDPR); -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.pipeda' | translate"
          >
            <!-- Canada’s Personal Information Protection and Electronic Documents
            Act (PIPEDA); -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.australia' | translate"
          >
            <!-- The Australian Privacy Act 1988; and -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.japan' | translate"
          >
            <!-- The Australian Privacy Act 1988; and -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.laws.other' | translate"
          >
            <!-- Any other applicable data protection or privacy laws in
            jurisdictions where my personal data may be processed. -->
          </li>
        </ul>
        <p
          class="mt-1"
          style="text-indent: 25px"
          [innerHTML]="'agreement.powersText' | translate"
        >
          <!-- Pursuant to this authorization, GotYourBack Technologies Ltd. is
          empowered to initiate, manage, and follow through on any and all
          privacy-related requests, including but not limited to: -->
        </p>
        <ul class="mt-1 agreement-list">
          <li
            class="agreement-item"
            [innerHTML]="'agreement.powers.access' | translate"
          >
            <!-- Requesting access to, or the correction, restriction, or deletion
            of, my personal data; -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.powers.optOut' | translate"
          >
            <!-- Opting out of data sales, sharing, targeted advertising, profiling,
            and other processing activities; -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.powers.withdraw' | translate"
          >
            <!-- Withdrawing previously granted consent for the collection or use of
            my personal data; -->
          </li>
          <li
            class="agreement-item"
            [innerHTML]="'agreement.powers.transfer' | translate"
          >
            <!-- Facilitating international transfers of personal data as required to
            complete these actions. -->
          </li>
        </ul>
        <p
          class="mt-1"
          style="text-indent: 25px"
          [innerHTML]="'agreement.communicationText' | translate"
        >
          <!-- GotYourBack Technologies Ltd. may communicate directly with
          third-party data controllers, data brokers, and other relevant
          entities as necessary to fulfill these requests and may provide any
          supporting information or documentation required to authenticate or
          validate the request. -->
        </p>
        <p
          class="mt-1"
          style="text-indent: 25px"
          [innerHTML]="'agreement.effortsText' | translate"
        >
          <!-- I acknowledge that GotYourBack Technologies Ltd. will make
          commercially reasonable efforts to execute these requests effectively;
          however, the Agent cannot guarantee the compliance or cooperation of
          third-party data recipients, and the outcomes of such requests may be
          influenced by factors beyond the Agent’s control. -->
        </p>
        <p
          class="mt-1"
          style="text-indent: 25px"
          [innerHTML]="'agreement.durationText' | translate"
        >
          <!-- This authorization shall remain in effect for the duration of my
          active subscription to GotYourBack Technologies Ltd. services and
          shall automatically terminate upon the termination or expiration of
          said subscription. I retain the right to revoke this authorization at
          any time, with written notice to GotYourBack Technologies Ltd.. -->
        </p>
      </div>
      <div [ngClass]="{ hidden: isCanvasHidden }">
        <br />
        <div>
          <canvas
            #canvas
            class="signature-canvas"
            (mousedown)="startDrawing($event)"
            (mousemove)="draw($event)"
            (mouseup)="stopDrawing()"
            (mouseleave)="stopDrawing()"
            (touchstart)="startDrawing($event)"
            (touchmove)="draw($event)"
            (touchend)="stopDrawing()"
          ></canvas>
        </div>
        <div class="text-center">
          <span class="d-inline-block" style="padding: 10px">
            <button (click)="clearSignature()" class="btn btn-primary">
              <!-- Clear -->
              {{ "agreement.clearButton" | translate }}
            </button>
          </span>
          <span class="d-inline-block" style="padding: 10px">
            <button
              (click)="saveSignature()"
              class="btn btn-primary"
              [disabled]="!checkSignature()"
            >
              <!-- Save -->
              {{ "agreement.saveButton" | translate }}
            </button>
          </span>
        </div>
        <br />
      </div>
      <div
        *ngIf="isLoaderActive"
        class="row justify-content-center align-items-center loader-wrapper"
      >
        <div class="col-auto">
          <div class="loader"></div>
        </div>
      </div>
      <div *ngIf="isSaved && !isLoaderActive" class="dashboard-container">
        <!--        <button class="btn btn-dashboard">-->
        <!--          <i class="fas fa-tachometer-alt"></i> Go to Dashboard-->
        <!--        </button>-->
        <div class="alert-big alert alert-success" role="alert">
          <div class="alert-content">
            <h6 class="alert-heading">
              <!-- You're all set! -->
              {{ "agreement.successTitle" | translate }}
            </h6>
            <p>
              <!-- Thanks for completing the authorization form. -->
              {{ "agreement.successText1" | translate }}
            </p>
            <p>
              <!-- Welcome aboard — your dashboard is ready, and you're good to go! -->
              {{ "agreement.successText2" | translate }}
            </p>
          </div>
        </div>
        <div class="text-center">
          <a
            href="javascript:void(0)"
            class="get-started-link"
            (click)="switchFormVisibility($event)"
          >
            <button
              class="btn btn-success get-started-btn btn-default btn-squared text-capitalize px-30"
            >
              <!-- Get Started -->
              {{ "agreement.getStarted" | translate }}
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
